import type { TeamUser } from '@central/api';

/**
 * "Passkey", "TOTP", "Via SSO" or "None": the strongest Central second factor
 * the user has; without one, an SSO-linked user's second factor is the IdP's.
 */
export function mfaLabel(u: TeamUser): string {
  if (u.secondFactors.passkeys > 0) return 'Passkey';
  if (u.secondFactors.totp) return 'TOTP';
  return u.sso ? 'Via SSO' : 'None';
}

/** True when u is the team's only enabled Owner, whom no one can disable or demote. */
export function isLastOwner(u: TeamUser, users: TeamUser[]): boolean {
  if (u.role !== 'Owner' || !u.enabled) return false;
  return users.filter((x) => x.role === 'Owner' && x.enabled).length === 1;
}
